import type { FileUploaderFileFormat } from '../types';

/**
 * Infiere el formato visual a partir de la extensión del nombre de archivo.
 * Extensiones desconocidas se tratan como `api` (etiqueta genérica en Figma).
 */
export function inferFileFormat(fileName: string): FileUploaderFileFormat {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  const map: Record<string, FileUploaderFileFormat> = {
    pdf: 'pdf',
    csv: 'csv',
    jpg: 'jpg',
    jpeg: 'jpg',
    png: 'png',
    mp4: 'mp4',
  };
  return map[ext] ?? 'api';
}
